import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const sections = document.querySelectorAll('section.investments');
if (sections.length) {
    sections.forEach(section => {
        const swiperEl = section.querySelector('.swiper-slider');
        const paginationEl = section.querySelector('[swiper-pagination]');
        const prevEl = section.querySelector('[swiper-prev]');
        const nextEl = section.querySelector('[swiper-next]');
        if (swiperEl) {
            const swiper = new Swiper(swiperEl, {
                spaceBetween: 16,
                pagination: {
                    el: paginationEl,
                    type: 'progressbar',
                },
                modules: [Pagination, Navigation],
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    1280: {
                        slidesPerView: 4,
                    },
                },
            });
        }
    });
}
